import React from 'react';
import { Avatar, AvatarGroup, Box, Typography } from '@mui/material';
import { CardActions, FONT, PositionBadge, StatusPill, cardSx } from './contentShared';

const LayoutCard = ({ layout, onEdit, onDelete, onOpenGallery }) => {
  const products = Array.isArray(layout.products) ? layout.products : [];
  const images = products.map((p) => p?.image).filter(Boolean);

  return (
    <Box sx={{ ...cardSx, cursor: 'pointer' }} onClick={() => onOpenGallery && onOpenGallery(layout)}>
      <Box sx={{ p: 2.5, display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
        <Box sx={{ minWidth: 150 }}>
          {images.length > 0 ? (
            <AvatarGroup max={5} sx={{ justifyContent: 'flex-end', '& .MuiAvatar-root': { width: 52, height: 52, fontSize: 12.5, fontWeight: 800, fontFamily: FONT, border: '3px solid #fff' } }}>
              {images.slice(0, 8).map((src, i) => <Avatar key={i} src={src} alt={`${layout.type} ${i + 1}`} />)}
              {images.length > 8 && <Avatar>+{images.length - 8}</Avatar>}
            </AvatarGroup>
          ) : (
            <Typography sx={{ fontFamily: FONT, fontSize: 11.5, color: '#94a3b8' }}>No product images</Typography>
          )}
        </Box>
        <Box sx={{ flex: 1, minWidth: 180 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
            <PositionBadge position={layout.position} />
            <Typography sx={{ fontFamily: FONT, fontWeight: 800, fontSize: 15.5, color: '#0f172a' }}>{layout.type}</Typography>
          </Box>
          <Typography sx={{ fontFamily: FONT, fontSize: 11.5, color: '#64748b' }}>
            {layout.layout} · {products.length} product{products.length === 1 ? '' : 's'}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <StatusPill status={layout.status} />
          <CardActions onView={() => onOpenGallery && onOpenGallery(layout)} onEdit={() => onEdit && onEdit(layout)} onDelete={() => onDelete && onDelete(layout)} />
        </Box>
      </Box>
    </Box>
  );
};

export default LayoutCard;
